import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { HOTELS } from '@shared/helpers/routes';

import Steps from '@shared/components/Steps/steps';
import { ConfirmDialogModal } from '@shared/components/Dialogs';

const StepsWrapper = ({ isaBuying = true }) => {
  const { business_types } = useSelector(store => store.pageConfiguration);

  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  return (
    <>
      <Steps
        setShowModal={setShowModal}
        searchData={{ emit: isaBuying ? false : true }}
        activeStep={2}
        stepsConfig={{
          box1: {
            subtitle: 'Seleccioná tu alojamiento',
            subtitleMobile: 'Alojamiento seleccionado',
          },

          box2: {
            subtitle:
              business_types.id === 2
                ? 'Ingresa los datos del pasajero'
                : 'Ingresá tus datos personales',

            subtitleMobile:
              business_types.id === 2
                ? 'Datos del pasajero'
                : 'Datos personales',
          },

          box3: isaBuying
            ? {
                subtitle: 'Pagá y confirmá tu reserva',
                subtitleMobile: 'Pagar y confirmar',
              }
            : null,
        }}
      />

      <ConfirmDialogModal
        isOpen={showModal}
        onConfirm={() => {
          history.push({
            pathname: HOTELS,
            state: { goBack: true },
          });
          setShowModal(false);
        }}
        onCancel={() => setShowModal(false)}
        text="¿Estás seguro de salir? Se borrarán los datos cargados."
      />
    </>
  );
};

export default StepsWrapper;
